import * as Types from 'src/actions/contact-form/send/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'src/reducers/RootReducer';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import ContactForm from 'src/value-objects/ContactForm';

export interface SendContactFormAttempt extends Action {
  type: Types.SEND_CONTACT_FORM_ATTEMPT;
}

export interface SendContactFormSuccess extends Action {
  type: Types.SEND_CONTACT_FORM_SUCCESS;
}

export interface SendContactFormFailure extends Action {
  type: Types.SEND_CONTACT_FORM_FAILURE;
  payload: {};
}

export type SendContactFormAction = SendContactFormAttempt |
  SendContactFormSuccess |
  SendContactFormFailure;

export interface SendContactFormThunk extends
  ThunkAction<Promise<SendContactFormAction>, RootState, null> {
}

export const SendContactFormAttempt: ActionCreator<SendContactFormAttempt> = (
) => (
  {
    type: Types.SEND_CONTACT_FORM_ATTEMPT,
  }
);

export const SendContactFormSuccess: ActionCreator<SendContactFormSuccess> = (
) => (
  {
    type: Types.SEND_CONTACT_FORM_SUCCESS,
  }
);

export const SendContactFormFailure: ActionCreator<SendContactFormFailure> = (error: {}) => (
  {
    type: Types.SEND_CONTACT_FORM_FAILURE,
    payload: error
  }
);

export const sendContactForm: ActionCreator<SendContactFormThunk> = (
  contactForm: ContactForm
): SendContactFormThunk => {

  return (dispatch: Dispatch<RootState>): Promise<SendContactFormAction> => {
    dispatch(SendContactFormAttempt());

    return ApiClient.contactForm.create(contactForm)
      .then((response: AxiosResponse): SendContactFormSuccess => {

        return dispatch(SendContactFormSuccess());
      }).catch((e: { response: { data: { error: Error } } }): SendContactFormFailure => {
        const errorMessages = e && e.response && e.response.data && e.response.data.error || {
          serverConnection: 'Error en la conexión, por favor inténtelo más tarde'
        };
        return dispatch(SendContactFormFailure(errorMessages));
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/contact-form/send/SendContactForm.actions.tsx